import { 
  Autocomplete, 
  Box, 
  Grid, 
  TextField, 
  Divider, 
  Chip,  
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Stack,
  Collapse
} from "@mui/material"
import React, {useState, useEffect} from "react"
import { RemovalsDataType, statusOptions, statusFilterType, RemovalSortByType, SortType, RemovalRangeFilterType, RemovalRangeFilterOptions,
 RemovalBrokerSourceFilterOptions,executionStatusFilterType, executionStatusOptions, dateRangeFilter, RemovalsReportUsersFilterType , RemovalsReportFilterOptions
} from "../Types"
import dayjs from 'dayjs'
import CustomDatePicker from '../../../shared/atom/inputs/DatePicker';
import { ArrowDownward, ArrowUpward, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import {getFilters, getSearchFilters, getRangeFilters, formatFromReportDateString } from '../../../../utils/helpers';
import CustomTablePagination from "../../../shared/atom/TablePagination/TablePagination"
import { BROKER_LISTS } from '@meprism/shared/src/utils/constants'
import {CircularProgress} from "@mui/material"
import { useAppDispatch } from '../../../../redux/storeExports';
import { createPaginatedReportApi, PaginatedReportArgs, PaginatedReportReturn } from '../../../../redux/corporateCodeService';
import { LookerReportsErrors } from '../../../shared/molecule/LookerReportsErrors';

type RemovalReportProps = {
  removalReportSyncTime : string
};

export const RemovalsTab = ({removalReportSyncTime}: RemovalReportProps) =>{
    const dispatch = useAppDispatch()    
    const [removalsData, setRemovalsData] = useState<RemovalsDataType[]>([])
    const [expandedRow, setExpandedRow] = useState<null | number>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [searchValue, setSearchValue] = useState('')
    const [statusFilter, setStatusFilter] = useState<statusFilterType[]>([])
    const [executionStatusFilter, setExecutionStatusFilter] = useState<executionStatusFilterType[]>([])
    const [removalRetryFilter, setRemovalRetryFilter] = useState<number | null>(null)
    const [confirmatorRetryFilter, setConfirmatorRetryFilter] = useState<number | null>(null)
    const [brokerFilter, setBrokerFilter] = useState<string[]>([])
    const [brokerSourceFilter, setBrokerSourceFilter] = useState<string[]>(['4ScreenMedia'])
    const [startDate, setStartDate] = useState<dayjs.Dayjs | undefined>(undefined)
    const [endDate, setEndDate] = useState<dayjs.Dayjs | undefined>(undefined)
    const [rangeFilter, setRangeFilter] = useState<RemovalRangeFilterType | null>(null)
    const [sortType, setSortType] = useState<SortType>('DESC') 
    const [sortBy, setSortBy] = useState<RemovalSortByType>('scan_date')
    const [sortStyle, setSortStyle] = useState({'confirmator_date':'ASC', 'removal_date':'ASC', 'scan_date':'DESC'})
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [hasNext, setHasNext] = useState(false)
    const [refetch, setRefetch] = useState(true)
    const [fetchNextPage, setFetchNextPage] = useState(false)
    const [newPage, setNewPage] = useState(0)
    const [usersFilter, setUsersFilter] = useState<RemovalsReportUsersFilterType>('All Users')
    const [offset, setOffset] = useState(0)
    const [dateRangeFilterErrors, setDateRangeFilterErrors] = useState(dateRangeFilter);
    const ToggleSort = (sortByValue: RemovalSortByType) => {
        const newSort = sortStyle[sortByValue] === 'ASC' ? 'DESC' : 'ASC'
        setSortStyle({ ...sortStyle, [sortByValue]: newSort })
        setSortType(newSort)
        setSortBy(sortByValue)
        setRefetch(true)
    }

    const getSortStyle = (sortByValue: RemovalSortByType) => {
        const Icon = sortStyle[sortByValue] === 'DESC' ? ArrowDownward : ArrowUpward;
        const color = sortBy === sortByValue ? 'error' : 'primary';
        return <Icon color={color}/>;
    };


    const colStyle = {
        fontSize: '16px',
        whiteSpace: 'nowrap',
        minWidth: 'max-content',
        maxWidth: 'max-content'
    }

    useEffect(()=>{
            if(startDate && !endDate){
                setEndDate(dayjs())
            }
        }, [startDate, endDate])

    useEffect(()=>{
        const fetchUsersReport= async()=>{
            setIsLoading(true)
            let newOffset = 0;
            try{
                if(fetchNextPage){
                    if(newPage < page){
                        newOffset = Math.max(offset - pageSize, 0)
                        setPage(page -1)
                    }else{
                        newOffset = pageSize + offset
                        setPage(page +1)
                    }
                }
                const CorpUsersFilter = (usersFilter && usersFilter === 'Corporate Users')? true : null 
                const params : PaginatedReportArgs = {
                "table" : "removals_reporting",
                "page_size": pageSize,
                "sort_by": sortBy,
                "offset" : fetchNextPage? newOffset : 0, 
                "order" : sortType,
                "Filters":{
                        "filters": getFilters({"status": statusFilter, "execution_status": executionStatusFilter, 'removal_retries': removalRetryFilter, 'confirmator_retries': confirmatorRetryFilter, 'broker_source': brokerSourceFilter
                        , 'is_corporate_user': CorpUsersFilter}),
                        "search_filter" : getSearchFilters([searchValue, brokerFilter]),
                        "date_range_filter": getRangeFilters([{rangeFilter, startDate, endDate}])
                    }
                }
                const response : PaginatedReportReturn = await dispatch(createPaginatedReportApi(params)).unwrap()
                setRemovalsData(response.data)
                setHasNext(response.has_next)
            }
            catch(e){
                console.log('error getting looker removals report: ', e)
            }finally{
                setIsLoading(false)
                if (fetchNextPage) {
                        setOffset(newOffset)
                } else {
                    setOffset(0)
                }
                setFetchNextPage(false)
            }
        }
        if(refetch){
            if(!fetchNextPage){
                setPage(1)
            }
            fetchUsersReport()
        }
        setRefetch(false)
    },[refetch, searchValue, rangeFilter, startDate, endDate, dispatch,
        brokerFilter, confirmatorRetryFilter, executionStatusFilter, removalRetryFilter, statusFilter,
        pageSize, sortBy, sortType, offset, fetchNextPage, newPage, page, brokerSourceFilter, usersFilter
    ])
    
        const getNextPage = (newPage: number)=>{
            setNewPage(newPage)
            setFetchNextPage(true)
            setRefetch(true)
        }
        
        const setNewPageSize = (newPageSize: number)=>{
            setPageSize(newPageSize)
            setRefetch(true)
        }

        const onSearch = () => {        
            const checkDateRangeError = Boolean(startDate || endDate || rangeFilter);
            if(checkDateRangeError){
                const newErrors = {
                    startDate: !startDate,
                    endDate: !endDate,
                    dateFilter: !rangeFilter,
                };
                const hasError = Object.values(newErrors).some(value => value === true);
                setDateRangeFilterErrors(newErrors);
                if (hasError) return
            }
            setDateRangeFilterErrors(dateRangeFilter)
            setRefetch(true);
        };
        

    return(
        <Box width={'100%'}>
            {isLoading?
                <Box
                    sx={{
                        width: '100%',
                        height: '50vh',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}>
                    <CircularProgress sx={{ alignSelf: 'center', justifySelf: 'center' }} />
                </Box>
               :<>
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>                
                        <Grid container spacing={4} mb={10} mt={5} width={'80vw'}>
                             <Grid item lg={12} md={12} xs={12} mb={5} sx={{display:'flex'}}>
                                <Box
                                    sx={{border:'1px green solid', backgroundColor:"white", py:3, px:2, borderRadius:2, color:"green"}}
                                >
                                    <Typography variant='h4' sx={{color:'success.main'}}>Last Data Sync: {removalReportSyncTime}</Typography>
                                </Box>
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <TextField
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    label="Search By Muid"
                                    size="small"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <Autocomplete
                                    multiple
                                    options={statusOptions}
                                    value={statusFilter}
                                    onChange={(event, newValue) => {
                                        setStatusFilter(newValue as statusFilterType[]);
                                    }}
                                    clearOnEscape
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                    />
                                    )}
                                    fullWidth
                                    limitTags={1}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option} {...getTagProps({ index })} />
                                    ))
                                    }
                                />
                            </Grid>

                            <Grid item lg={4} md={6} xs={12}>
                                <Autocomplete
                                    multiple
                                    options={executionStatusOptions}
                                    value={executionStatusFilter}
                                    onChange={(event, newValue) => {
                                        setExecutionStatusFilter(newValue as executionStatusFilterType[]);
                                    }}
                                    clearOnEscape
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Execution Status"
                                    />
                                    )}
                                    fullWidth
                                    limitTags={1}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option} {...getTagProps({ index })} />
                                    ))
                                    }
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <Autocomplete
                                    options={RemovalsReportFilterOptions}
                                    value={usersFilter}
                                    disableClearable
                                    onChange={(event, newValue) => {
                                        setUsersFilter(newValue as RemovalsReportUsersFilterType);
                                    }}
                                    defaultValue={'All Users'}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="User Type"
                                    />
                                    )}
                                    fullWidth
                                    isOptionEqualToValue={(option, value) => option === value}
                                    
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                    <Autocomplete
                                    options={['0','1','2','3']}
                                    value={removalRetryFilter !== null && removalRetryFilter !== undefined ? removalRetryFilter.toString() : null}
                                   onChange={(event, newValue) => {
                                        if (newValue !== null) setRemovalRetryFilter(parseInt(newValue));
                                        else setRemovalRetryFilter(null);
                                    }}
                                    clearOnEscape
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Filter By Removal Retries"
                                    />
                                    )}
                                    fullWidth
                                    isOptionEqualToValue={(option, value) => option === value}
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                    <Autocomplete
                                    options={['0','1','2','3']}
                                    value={confirmatorRetryFilter !== null && confirmatorRetryFilter !== undefined ? confirmatorRetryFilter.toString() : null}
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) setConfirmatorRetryFilter(parseInt(newValue));
                                        else setConfirmatorRetryFilter(null);
                                    }}
                                    clearOnEscape
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Filter By Confirmator Retries"
                                    />
                                    )}
                                    fullWidth
                                    isOptionEqualToValue={(option, value) => option === value}
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <Autocomplete
                                    multiple
                                    freeSolo
                                    options={BROKER_LISTS}
                                    value={brokerFilter}
                                    onChange={(event, newValue) => {
                                        setBrokerFilter(newValue);
                                    }}
                                    clearOnEscape
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Filter by Broker"
                                        />
                                    )}
                                    fullWidth
                                    limitTags={1}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip label={option} {...getTagProps({ index })} />
                                        ))
                                    }
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <Autocomplete
                                    multiple
                                    options={RemovalBrokerSourceFilterOptions}
                                    value={brokerSourceFilter}
                                    onChange={(event, newValue) => {
                                        setBrokerSourceFilter(newValue);
                                    }}
                                    clearOnEscape
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Filter by Broker Source"
                                        />
                                    )}
                                    fullWidth
                                    limitTags={1}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip label={option} {...getTagProps({ index })} />
                                        ))
                                    }
                                />
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <Autocomplete
                                    options={RemovalRangeFilterOptions}
                                    value={rangeFilter}
                                    onChange={(event, newValue) => {
                                        //@ts-ignore
                                        setRangeFilter(newValue);
                                    }}
                                    clearOnEscape
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Filter By Date"
                                    />
                                    )}
                                    fullWidth
                                    isOptionEqualToValue={(option, value) => option === value}
                                />
                                {
                                    dateRangeFilterErrors['dateFilter'] && <LookerReportsErrors errorKey='date type' filter='date'/>
                                }
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <CustomDatePicker
                                    label="Start Date"
                                    value={startDate? startDate : null}
                                    onChange={(value)=>{value? setStartDate(value): setStartDate(undefined)}}
                                    disableFuture
                                    clearable
                                    maxDate={endDate}
                                />
                                {
                                    dateRangeFilterErrors['startDate'] && <LookerReportsErrors errorKey='start date' filter='date'/>
                                }
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <CustomDatePicker
                                    label="End Date"
                                    value={endDate? endDate : null}
                                    onChange={(value)=>{value? setEndDate(value): setEndDate(undefined)}}
                                    disableFuture
                                    clearable
                                    minDate={startDate}
                                />
                                {
                                    dateRangeFilterErrors['endDate'] && <LookerReportsErrors errorKey='end date' filter='date'/>
                                }
                            </Grid>
                            <Grid item lg={4} md={6} xs={12}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => onSearch()}
                                    sx={{minWidth: '50%', height: '100%'}}                                                    
                                >
                                    Search
                                </Button>
                            </Grid>
                            
                        </Grid>
                    </Box>
                    <Divider sx={{mt: 5, mb: 5}}/>
                    <TableContainer component={Paper} style={{ marginTop: 20 }}>
                        <Table sx={{minWidth: 1580, overflow: 'auto' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>MUID</TableCell>
                                    <TableCell>Broker</TableCell>
                                    <TableCell>Child Brokers</TableCell>
                                    <TableCell>Broker Source</TableCell>
                                    <TableCell>Execution Status</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Profile URL</TableCell>
                                    <TableCell>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            Scan Date
                                            <Button onClick={(e: React.MouseEvent)=>
                                                        {
                                                            setSortBy('scan_date')
                                                            ToggleSort('scan_date')
                                                        }}
                                                    >
                                                    {getSortStyle('scan_date')}
                                            </Button>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{display:'flex'}}>
                                        <Box display="flex" alignItems="center" gap={1}>
                                        Removal Date
                                            <Button onClick={(e: React.MouseEvent)=>
                                                    {
                                                        setSortBy('removal_date')
                                                        ToggleSort('removal_date')
                                                    }}
                                            >
                                                {getSortStyle('removal_date')}
                                            </Button>
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Box display="flex" alignItems="center" gap={1}>
                                            Confirmator Date
                                            <Button onClick={(e: React.MouseEvent)=>
                                                        {
                                                            setSortBy('confirmator_date')
                                                            ToggleSort('confirmator_date')
                                                        }}
                                                    >
                                                    {getSortStyle('confirmator_date')}
                                            </Button>
                                        </Box>
                                    </TableCell>
                                    <TableCell>Removal Retries</TableCell>
                                    <TableCell>Confirmator Retries</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(removalsData) &&
                                    removalsData.length===0 &&
                                    <TableRow>
                                        <TableCell colSpan={11} sx={{textAlign:"center"}}>
                                            No Match Found
                                        </TableCell>
                                    </TableRow>
                                }
                                {Array.isArray(removalsData) && removalsData.length!==0 && removalsData
                                    .map((row: RemovalsDataType, index: number) => (
                                    <>
                                    <TableRow
                                        key={index}
                                        sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"}}
                                    >
                                        <TableCell>
                                            {Boolean(row.broker_child_count) &&
                                            <Button onClick={()=>expandedRow===index?setExpandedRow(null):setExpandedRow(index)}>
                                                {expandedRow===index?
                                                <KeyboardArrowUp/> :
                                                <KeyboardArrowDown/>}
                                            </Button>}
                                        </TableCell>
                                        <TableCell sx={colStyle}>{row.muid}</TableCell>
                                        <TableCell sx={colStyle}>{row.broker}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 150}}>{row.broker_child_count}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 150}}>{row.broker_source}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 150}}>{row.execution_status}</TableCell>
                                        <TableCell sx={colStyle}>{row.status}</TableCell>
                                        <TableCell sx={colStyle}><a href={row.profile_url}>View Profile</a></TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 180}}>{row.scan_date? formatFromReportDateString(row.scan_date): '-'}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 180}}>{row.removal_date? formatFromReportDateString(row.removal_date) : '-'}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 220}}>{row.confirmator_date? formatFromReportDateString(row.confirmator_date) : '-'}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 150}}>{row.removal_retries}</TableCell>
                                        <TableCell sx={{...colStyle, minWidth: 170}}>{row.confirmator_retries}</TableCell>
                                    </TableRow>
                                    {Boolean(row.broker_child_count) &&
                                        <TableRow>
                                            <TableCell colSpan={7} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                                                <Collapse
                                                in={expandedRow === index}
                                                timeout="auto"
                                                unmountOnExit
                                                >
                                                    <Stack
                                                        spacing={2}
                                                        px={2}
                                                        py={4}
                                                        direction="row"
                                                        sx={{     
                                                            rowGap: 2,                
                                                            columnGap: 2,             
                                                            minHeight: '120px',
                                                            height: 'auto',
                                                            maxHeight: 'max-content'
                                                        }}
                                                        >
                                                        <Typography
                                                            variant="h3"
                                                            alignSelf="center"
                                                            maxWidth={100}
                                                            minWidth={100}
                                                        >
                                                            Child Brokers Details
                                                        </Typography>
                                                        <Stack
                                                            spacing={0}
                                                            px={2}
                                                            py={4}
                                                            direction="row"
                                                            sx={{
                                                                flexWrap: 'wrap',         
                                                                rowGap: 2,                
                                                                columnGap: 4,             
                                                                minHeight: '120px',
                                                                height: 'auto',
                                                                maxHeight: 'max-content',
                                                                alignItems:'center'
                                                            }}
                                                        >
                                                            {row.broker_children.map((child: string, index: number) => (
                                                                <Paper
                                                                key={index}
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '10px',
                                                                    ...colStyle,
                                                                    minWidth: 190,
                                                                    height:60
                                                                }}
                                                                >
                                                                    <Typography variant="body2" fontWeight="bold">
                                                                        {index + 1}. {child}
                                                                    </Typography>
                                                                </Paper>
                                                            ))}
                                                        </Stack>
                                                        </Stack>

                                            </Collapse>
                                        </TableCell>
                                    </TableRow>}
                                    </>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <CustomTablePagination
                        onPageChange={(newPage: number) => getNextPage(newPage)}
                        onPageSizeChange={(pageSize: number) =>
                            setNewPageSize(pageSize)
                        }
                        page={page}
                        pageSize={pageSize}
                        hasNext={hasNext}
                    />
                </>
            }
        </Box>
    )
}